import React from 'react';
import {Fab} from '@material-ui/core';
import {Add as AddIcon, Assignment as ResultsIcon, Visibility, Share, MoreVert, Edit as EditIcon, Delete as DeleteIcon} from '@material-ui/icons';
import {fetchQuizzes} from 'api/quiz';
import {Link, withRouter} from 'react-router-dom';
import {DeletionConfirm, ThinkscapeTable} from '../../components/common';
import Modal from '../common/Modal';
import QuizShare from './QuizShare';
import { Menu, MenuItem, Button, IconButton } from '@material-ui/core';
import { deleteQuiz} from 'api/quiz';
import MoreMenu from '../common/MoreMenu';
import {addFlashMessage} from '../../actions/flash-message';
import {connect} from 'react-redux';
import {createForm} from 'rc-form';
import PropTypes from 'prop-types';
import {SecondaryButton} from '../common/StyledButtons';
import QuizImport from './QuizImport';
import FileUpload from '../common/fields/FileUpload';

class QuizList extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            selectedQuiz: '',
            modalOpen: false,
            anchorEl: null,
            menuOpen: false,
            shouldDeleteQuiz: false,
            quizToDelete: '',
            showImportModal: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deletionConfirmBoxRef = React.createRef();
        this.tableDataRef = React.createRef();
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.showImportModal = this.showImportModal.bind(this);
    }

    handleClick(quizId, event){
        this.setState({anchorEl: event.currentTarget, menuOpen: true, selectedQuiz: quizId});
    }

    handleClose(){
        this.setState({anchorEl: null, menuOpen:false});
    }

    handleDeleteClick(quiz){
        this.setState({quizToDelete: quiz,
            shouldDeleteQuiz: true}, this.deletionConfirmBoxRef.current.openModal);
    }

    handleDelete(quizId){
        const { addFlashMessage } = this.props;
        this.setState({shouldDeleteQuiz: false});
        deleteQuiz(quizId)
            .then(response => {
                this.context.router.history.push('/quizzes');
                addFlashMessage(response.message, 'success');
            })
            .catch(() => {
                this.context.router.history.push('/quizzes');
                addFlashMessage('Quiz could not be deleted: Quiz not found', 'error');
            });
    }

    showImportModal(){
        this.setState({showImportModal: true});
    }

    render() {
        const {modalOpen, selectedQuiz, quizToDelete, showImportModal } = this.state;

        return (
            <div className="content-box">
                <DeletionConfirm
                    ref={this.deletionConfirmBoxRef}
                    itemName={quizToDelete.name}
                    deleteAction={() => this.handleDelete(quizToDelete.id)}
                    DeleteButton="span"
                />
                <Modal
                    title="Share Quiz"
                    onClose={() => this.setState({modalOpen: false})}
                    open={modalOpen}
                    maxWidth="md"
                >
                    <QuizShare selectedQuiz={selectedQuiz}/>
                </Modal>
                <Modal title=""
                    onClose={() => this.setState({showImportModal: false})}
                    open={showImportModal}
                    maxWidth="md"
                >
                    <QuizImport/>
                </Modal>
                <h1 className="section-header">
                    <div className="section-title">My Quizzes</div>
                </h1>
                <div>
                    <div className="pull-right quizscape-action-btn">
                        <Link to="/quizzes/new">
                            <SecondaryButton>
                                Create New Quiz
                            </SecondaryButton>
                        </Link>
                        <Button color="secondary" onClick={this.showImportModal}>
                            Import Quiz
                        </Button>
                    </div>
                    <ThinkscapeTable
                        ref = {this.tableDataRef}
                        searchBoxPlaceholder="Search Quizzes"
                        itemName="quizzes"
                        getFieldsMapping={(question) => (
                            {
                                name: question.name || '',
                                report: '',
                                share: '',
                                edit: '',
                                actions: '',

                            })
                        }
                        fetchRecords={(args) => fetchQuizzes({
                            ...args,
                        })}
                        fieldsSettings={
                            {
                                name: {
                                    sortable: true,
                                    fieldText: 'Name',
                                    formatData: (cell, row) => <Link to={`/quizzes/${row.id}/edit`}>{row.name}</Link>
                                },
                                report: {
                                    noPadding: true,
                                    fieldText: 'Report',
                                    class: 'width-4-pc',
                                    formatData: (cell, row) => (
                                        <IconButton href={`/quizzes/${row.id}/reports`}>
                                            <ResultsIcon/>
                                        </IconButton>)
                                },
                                share: {
                                    noPadding: true,
                                    fieldText: 'Share',
                                    class: 'width-4-pc',
                                    formatData: (cell, row) => (
                                        <IconButton
                                            onClick={() => this.setState({modalOpen: true, selectedQuiz: row.id})}>
                                            <Share/>
                                        </IconButton>
                                    )
                                },
                                edit: {
                                    noPadding: true,
                                    fieldText: 'Edit',
                                    class: 'width-4-pc',
                                    formatData: (cell, row) => (
                                        <IconButton href={`/quizzes/${row.id}/edit`}>
                                            <EditIcon/>
                                        </IconButton>
                                    ),
                                },
                                actions: {
                                    noPadding: true,
                                    fieldText: 'Delete',
                                    class: 'width-4-pc',
                                    formatData: (cell, row) => (
                                        <IconButton onClick={() => this.handleDeleteClick(row)}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    ),
                                },
                            }
                        }
                    />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

QuizList.contextTypes = {
    router: PropTypes.object.isRequired
};

export default withRouter(connect(
    null,
    mapDispatchToProps
)(createForm()(QuizList)));